/* eslint-disable no-undef */
/* eslint-disable object-shorthand */
import { client } from "./client";

export const getAnticipationRule = () => client.get("account/anticipations/rule.json");
export const disableAutomaticAnticipations = () => client.delete("account/anticipations/rule.json");
export const enableAutomaticAnticipations = () => client.post("account/anticipations/rule.json");
export const anticipationRequestStatus = () => client.get("account/anticipations/request.json");
export const createAnticipationRequest = params => client.post("account/anticipations/request.json", params);
export const getAnticipationTax = () => client.get("account/anticipations/tax.json");
export const getBalance = () => client.get("account/balance.json");
export const getSummary = () => client.get("account/summary.json");
export const getBillingChart = params => client.post("payments/billing_chart.json", params);
export const getAverageTicket = params => client.post("payments/average_ticket.json", params);
export const getPaymentKind = params => client.post("payments/payment_kind.json", params);
export const getBrandChart = params => client.post("payments/brand_chart.json", params);
export const anticipationsAvailable = params => client.get("account/anticipations_available.json", { params: params });
export const createAnticipations = params => client.post("account/anticipations", params);
export const updatePassword = params => client.post("passwords/update", params);
export const updateAccount = (params, id) => client.patch(`account/${id}`, params);
export const getAccount = () => client.get("accounts");
export const getAccountTaxes = cardBrand =>
  client.get("account/get_account_taxes", { params: cardBrand ? { card_brand: cardBrand } : {} });
export const getAccountPayers = () => client.get("payerbills");
export const newAccountPayers = params => client.post("payerbills", { payer: params });
export const updateAccountPayers = params => client.post("payerbills/" + params.id, { payer: params });
export const deleteAccountPayers = params => client.delete("payerbills/" + params.id);
export const getAccountLends = () => client.get("account/lends");
export const getNotifications = () => client.get("notifications");
export const updateLiquidationAccount = params => client.post("account/liquidation/update", { send_deposits_to_flowit_wallet: params });
export const newLend = params => client.get("account/get_lend", { lend: params });

// Upload via backend Rails
export const sendLogo = async (file) => {
  const formData = new FormData();
  formData.append('partner_logo', file);

  return client.post("partner_upload_logo", formData, {
    // Deixa o navegador definir o Content-Type com o boundary correto do
    // multipart. Forçar "multipart/form-data" manualmente (sem boundary)
    // faz o backend não conseguir ler o arquivo e o upload falha ("Logo inválida").
    transformRequest: [(data, headers) => {
      if (headers) {
        delete headers['Content-Type'];
        delete headers['content-type'];
      }
      return data;
    }],
  });
};

export const sendFavicon = async (file) => {
  const formData = new FormData();
  formData.append('partner_favicon', file);

  return client.post("partner_upload_favicon", formData, {
    // Deixa o navegador definir o Content-Type com o boundary correto do multipart.
    transformRequest: [(data, headers) => {
      if (headers) {
        delete headers['Content-Type'];
        delete headers['content-type'];
      }
      return data;
    }],
  });
};

export const sendColor = params => client.post("partner_change_color", { panel_color: params });
